import { outboundAttachmentMaxCount } from './outboundAttachmentMaxCount'
import { outboundAttachmentMaxTotalBytes } from './outboundAttachmentMaxTotalBytes'

// The single copy of the outbound attachment ceiling message — the agent reply, batch reply
// and storefront reply paths all refuse an over-limit list with this reason.
export const outboundAttachmentLimitMessage = `Attachments are limited to ${outboundAttachmentMaxCount} files and ${outboundAttachmentMaxTotalBytes / 1024 / 1024} MB per message. Remove some files or share a link instead.`

export const getOutboundAttachmentLimitReason = (files?: { size?: number }[]): string | undefined => {
  const count = files?.length ?? 0
  const totalBytes = (files ?? []).reduce((sum, file) => sum + (file?.size ?? 0), 0)
  if (count > outboundAttachmentMaxCount || totalBytes > outboundAttachmentMaxTotalBytes) {
    return outboundAttachmentLimitMessage
  }
  return undefined
}
